module.exports = __webpack_public_path__ + "static/media/marketplace-header.aa6ff858.png";